<template>

  <i class="Icon" :class="'is--'+name" >
    <svg-vue :icon="'icon-'+name"/>
  </i>

</template>

<script>

  export default {
    props: [ "name", 'alt' ]
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Icon.scss";
</style>
